import React from 'react';

import Checkbox from '@/components/UI/FormElements/Checkbox';
import { _isEmpty } from '@/littledash';

import type { ProposedCage } from '../Recaging.utils';

interface SubmitSectionProps {
  loading: boolean;
  studyCagesLoading: boolean;
  proposedCages: ProposedCage[];
  deleteCages: boolean;
  onDeleteCagesChange: (checked: boolean) => void;
  onSubmit: (deleteCages: boolean) => void;
}

export const SubmitSection: React.FC<SubmitSectionProps> = ({
  loading,
  studyCagesLoading,
  proposedCages,
  deleteCages,
  onDeleteCagesChange,
  onSubmit,
}) => {
  return (
    <div className="flex items-center w-100 mv3 w-auto-ns mb0-ns">
      <button disabled={loading || studyCagesLoading || _isEmpty(proposedCages)} onClick={() => onSubmit(deleteCages)}>
        Submit
      </button>

      <Checkbox
        className={'dib pl3'}
        name="delete-cages"
        label="Delete empty cages in study"
        checked={deleteCages}
        onChange={({ target: { checked } }) => onDeleteCagesChange(checked)}
      />
    </div>
  );
};
